<ng-template #defaultTreeNodeTemplate let-node>
  {{node.label}}
</ng-template>

<cdk-virtual-scroll-viewport #treeElement
                             [itemSize]="30"
                             [minBufferPx]="200"
                             [maxBufferPx]="400"
                             role="tree"
                             [aria-label]="treeLabel"
                             [attr.aria-owns]="getAllRootNodeIds().join(' ')"
                             class="mat-tree tree-wrapper">
  <ng-container *cdkVirtualFor="let node of dataSource$; trackBy: treeTrackBy">
    <div [class.tree-node--selected]="selectedNodeId === node.id && !openInfoInTree"
         [class.tree-node--selected-with-info]="activeInTreeInfoNodes.includes(node.id) && openInfoInTree"
         [class.tree-node--multi-selected]="multiSelectedNodeIds.includes(node.id)"
         class="mat-tree-node"
         [class.mat-tree-node--folder]="hasChild(node)"
         [style.--tree-node-indent]="depth(node) * 20 + 'px'"
         tabindex="0"
         role="treeitem"
         [id]="node.id"
         [attr.aria-level]="node.level + 1"
         [attr.aria-expanded]="hasChild(node) ? isExpanded(node) : null"
         [attr.aria-selected]="selectedNodeId === node.id"
         [attr.aria-checked]="isChecked(node)"
         [attr.aria-setsize]="getSetSize$(node) | async"
         [attr.aria-posinset]="getPositionInSet$(node) | async"
         (click)="setNodeSelected(node, $event)"
         (dblclick)="onNodeDoubleClick ? onNodeDoubleClick(node) : null"
         (keydown.enter)="setNodeSelected(node)">
      <div [className]="getNodeClassName(node)"
           [attr.data-nodeid]="node.id"
           (dragstart)="treeDragDropServiceEnabled ? handleDragStart($event, node) : null">
        @if (!hasChild(node)) {
          @if (node.checkbox && !useRadioInputs) {
            <mat-checkbox [aria-label]="node.label"
                          [checked]="isChecked(node)"
                          [disabled]="readOnlyMode"
                          (click)="$event.stopPropagation()"
                          (change)="toggleLeafChecked(node)"
                          class="tree-node-checkbox"></mat-checkbox>
          } @else if (useRadioInputs) {
            <mat-radio-button [disabled]="readOnlyMode"
                              [checked]="isChecked(node)"
                              [aria-label]="node.label"
                              (click)="handleRadioChange(node, $event)"
                              [value]="node"
                              class="tree-radio-button"></mat-radio-button>
          }
        } @else {
          @if (!hideRootCollapseArrow || node.level !== 0) {
            <button mat-icon-button
                    class="size-18"
                    (click)="toggleNodeExpansion($event, node)"
                    [attr.aria-label]="(isExpanded(node) ? 'collapse ' : 'expand ') + node.label">
              <mat-icon [svgIcon]="isExpanded(node) ? 'chevron_bottom' : 'chevron_right'"></mat-icon>
            </button>
          }
          @if (node.checkbox && !useRadioInputs) {
            <mat-checkbox [disabled]="readOnlyMode"
                          [aria-label]="node.label"
                          (click)="$event.stopPropagation()"
                          (change)="toggleGroupChecked(node)"
                          [checked]="isChecked(node)"
                          [indeterminate]="isIndeterminate(node)"
                          class="tree-node-checkbox"></mat-checkbox>
          }
        }
        <div class="tree-node__drag-container"
             (mousedown)="enableDrag($event)"
             (mouseup)="stopDrag($event)"
             (touchstart)="enableDrag($event)"
             (touchend)="stopDrag($event)">
          @if (node.loadingPlaceholder) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <ng-container *ngTemplateOutlet="treeNodeTemplate ? treeNodeTemplate : defaultTreeNodeTemplate; context: {$implicit: node}"></ng-container>
          }
        </div>
      </div>
      @if (hasChild(node)) {
        <div [id]="'tree-group-' + node.id"
             class="tree-group"
             role="group"
             aria-hidden="false"
             [attr.aria-owns]="getChildren(node).join(' ')"></div>
      }
      @if (activeInTreeInfoNodes.includes(node.id)) {
        <div class="tree-node__info">
          <ng-container *ngTemplateOutlet="nodeInfoInTreeTemplate ? nodeInfoInTreeTemplate : null; context: {$implicit: node}"></ng-container>
        </div>
      }
    </div>
  </ng-container>
</cdk-virtual-scroll-viewport>

@if (extendedDropzone) {
  <div [class]="extendedDropzoneClass" #extendedDropzone></div>
}
